<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, computed, nextTick } from "vue";
import { onShowSite } from "@/NavigationHelper";
import { showSnackbar, showDialog } from "@/UIHelper";
import { isPhone } from "@/DeviceInfoPlugin";
import { toNumber } from "@/DataHelper";
import { Globals } from "@/Globals";
import Constants from "@/Constants";
import SelectZeitraum from "@/components/common/SelectZeitraum.vue";
import { begriffBezeichnung, globalsBezeichnung } from "@/local";
import {
  calcFunctionNew,
  getAufgabeDefinition,
  getKZAufgabeDefiniton,
} from "@/CalcHelperStatic";
import {
  getDisplay,
  getDisplayValue,
  getGroupSumValue,
  getKZColumn,
  getValue,
} from "@/DataHelper";
import { getMonthNames } from "@/editor/CalenderHelper";
import { globalsBegriffMemo, globalsDruck } from "@/local";
import BaseEditor from "@/components/BaseEditor.vue";
import CalcButton from "@/components/CalcButton.vue";
interface GridDialogData {
  aic?: number;
  title: string;
  componentName: string;
  zeitbereich?: APIZeitbereich;
  showCustomEditor: boolean;
  showCustomGrid: boolean;
  query: string;
  lastValues?: null;
  newData: boolean;
  bewegungsdaten: boolean;
  width: number;
  height?: number;
  fullscreen?: boolean;
  mainAic?: number;
  mainStt?: number;
  printItems?: ALLDruck[];
  abwAic?: number;
  keinZeitraum?: boolean;
  stammQuery?: string;
  auswahlQuery?: string;
  neuDialog?: string;
  mehrfach?: boolean;
  numberOfColumns?: number;
}
const emit = defineEmits<{
  (event: "back", valid?: boolean): void;
  (event: "alert", param: { text?: string; type?: string }): void;
  (event: "loaded", valid?: boolean): void;
  (event: "onReloadData", valid?: boolean): void;
}>();
const props = defineProps<{
  query?: string;
  showClose?: boolean;
  queryAic?: number;
  zeitbereich?: APIZeitbereich | null;
  preSelectedRow?: number;
  siteData?: any;
  mainStt?: number;
  printItems?: ALLDruck[];
  onlyVector?: boolean;
  modellItems?: ALLModell[];
  exportItems?: AbfrageItems[];
  hideHeader?: boolean;
  treeView?: boolean;
  title?: string;
  showTitle?: boolean;
  dark?: boolean;
  preloadedData?: QueryResponse;
  mainAic?: number;
  queryData?: QueryResponse;
  color?: string;
  formular?: ALLFrame;
  hideWhenEmpty?: boolean;
}>();

let showLoading = ref<boolean>(false);
let showLoadingSub = ref<boolean>(false);
let headers = ref<TableHeader[]>([]);
let header: QueryHeader = { bezeichnung: "hallo" };
let rowdata: QueryDataRow[] = [];
let bezeichnung = ref<string>("");
let noData = ref<boolean>(false);
let letzteDaten: boolean = false;
let letzteDatenAnzeigen: boolean = false;
let tableData = ref<QueryDataRow[]>([]);
let localeZeit = ref<string>(AUApi.Current.user.locale);

let visibleColumns: DataColumn[] = [];
let defColums: DataColumn[] = [];
const checkboxColumns = ref<DataColumn[]>([]);
const ampelColumns = ref<DataColumn[]>([]);
let colorColumn: DataColumn;
let aggregateColumns: DataColumn[] = [];
let allColumns: DataColumn[] = [];
let showGroupBy = ref<boolean>(false);
let groupedBy = ref<SortItem[]>([]);
let expanded: DataColumn[] = [];
let showExpand = ref<boolean>(false);
let showSearch = ref<boolean>(false);
let search = ref<string>("");
let columnsforGroupSummary: DataColumn[] = [];
let sortDesc: string[] = [];
let sortBy = ref<SortItem[]>([]);
let aic: number = 0;
let rowKey = ref<string>("aic_Stamm");
let showZeitraum = ref<boolean>(false);
let menu = ref<boolean>(false);
let setCompKey = ref<number>(0);
let setCompKeyZeitraum = ref<number>(0);
let date = ref<string>(
  new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" }),
);
let selectedYear: number = new Date().getFullYear();
let dateString: string =
  getMonthNames()[new Date().getMonth()] + " " + new Date().getFullYear();

let frageDelete: string = globalsBegriffMemo(
  Globals.Begriff,
  "Loeschen2",
  "Soll der Datensatz wirklich gelöscht werden?",
);
let dialogCopy = ref<boolean>(false);
let dialogDelete = ref<boolean>(false);
let frageCopy: string = globalsBegriffMemo(
  Globals.Begriff,
  "Kopie",
  "Soll der Datensatz kopiert werden?",
);
let showSelect = ref<boolean>(false);
let selected = ref<number[]>([]);
let pageSize = ref<number>(15);
const page = ref(1);
let dialogEdit = ref<boolean>(false);
let dialogInlineEdit = ref<boolean>(false);
let showDelete = ref<boolean>(false);
let showDeleteDetail: boolean = false;
let showNew = ref<boolean>(true);
let dialogOpen = ref<boolean>(false);
let dialogVerwendung = ref<boolean>(false);
let showDialogLocal: boolean = false;
let showBezeichnung = ref<boolean>(true);
let showCopy: boolean = false;
let showCopyStamm: boolean = false;
let showVerwendung: boolean = false;
let calcModell: string = "";
let subAbf: string = "";
let editAbf: string = "";
let aufgabenDefinition!: QueryResponse;
let isMobile = ref<boolean>(false);
let showCalcMenu = ref<boolean>(false);
const dialog = reactive<GridDialogData>({
  title: "--!!--",
  componentName: "None",
  showCustomEditor: false,
  showCustomGrid: false,
  query: "",
  newData: false,
  bewegungsdaten: false,
  width: 600,
  height: 600,
  fullscreen: false,
  mainAic: 0,
  mainStt: 0,
  printItems: [],
  abwAic: 0,
  keinZeitraum: false,
  mehrfach: false,
  numberOfColumns: 2,
});

const newDialog = reactive<GridDialogData>({
  title: "--!!--",
  componentName: "None",
  showCustomEditor: false,
  showCustomGrid: false,
  query: "",
  newData: false,
  bewegungsdaten: false,
  width: 600,
  height: 600,
  fullscreen: false,
  mainAic: 0,
  mainStt: 0,
  printItems: [],
  abwAic: 0,
  keinZeitraum: false,
  mehrfach: false,
  numberOfColumns: 2,
});

let subQuery: string = "";
let expandQuery: string = "";
let disableFooter = ref<boolean>(true);
let treeviewMutable: boolean = false;

let mainAicInternal: number = 0;
let lastQueryResponse!: QueryResponse;

let maxWidth = window.innerWidth;
let initialized = ref<boolean>(false);
let mainprintItems: ALLDruck[] = [];
let mainexportItems: AbfrageItems[] = [];
let mainSttInternal: number = 0;
const selectedRow = ref<number>(0);
let groupExpanded = ref<{}>({});
const groupValueLabelMap = ref<Record<string, string>>({});
let lokalZeitbereich = ref<APIZeitbereich>({
  von: AUApi.Current.zeitbereich.von,
  bis: AUApi.Current.zeitbereich.bis,
  bereich: "Monat",
});
let selectedAic!: number;

const expandColspan = computed(() => {
  let count = headers.value.length;
  if (showSelect.value) count += 1;
  if (showExpand.value) count += 1;
  return count;
});

// Von headers.value ableiten (statt vom nicht-reaktiven visibleColumns), damit die
// Summenzeile nach einem refresh()/dataLoaded() mit geänderter Spaltenanzahl nicht
// mit den echten Tabellenspalten auseinanderläuft. headers.value enthält zusätzlich
// ggf. eine angehängte Actions-Spalte ohne queryColumn - die wird hier rausgefiltert
// und in summaryExtraCells gezählt, damit die Summenzeile die gleiche Zellenanzahl hat.
const summaryColumns = computed(() =>
  headers.value
    .map((h) => (h as any).queryColumn as DataColumn | undefined)
    .filter((col): col is DataColumn => !!col),
);
const summaryExtraCells = computed(
  () => headers.value.filter((h) => !(h as any).queryColumn).length,
);

onMounted(async () => {
  if ((Constants.isMobile && isPhone()) || window.innerWidth < 600) {
    isMobile.value = true;
  }
  // datum in der Anzeige sauber stellen
  if (lokalZeitbereich.value) {
    const von = lokalZeitbereich.value.von;
    date.value = von.toISOStringWithTZGMT().substr(0, 7);
  }
  if (props.siteData) {
    // if (props.siteData.query) {
    //   props.query = props.siteData.query;
    // }
    // if (props.siteData.aic) {
    //   props.queryAic = props.siteData.aic;
    // }
    // if (props.siteData.zeitbereich) {
    //   props.zeitbereich = props.siteData.zeitbereich;
    //   const von = props.siteData.zeitbereich.von;
    //   date = [von.toISOStringWithTZGMT().substr(0, 7)];
    // }
  }
  treeviewMutable = props.treeView;
  if (props.zeitbereich) {
    lokalZeitbereich.value = { ...props.zeitbereich };
  }
  getAufgabeDefinition().then((r: any) => {
    aufgabenDefinition = r;
  });
  mainAicInternal = props.mainAic ?? props.queryAic ?? 0;
  mainSttInternal = props.mainStt ?? 0;
  await refresh();
  // Alle Gruppen standardmäßig geschlossen
  toggleAllGroups(true);
});

function fixKennungForProperty(column: any): string {
  let x = "g" + column.name;
  if (allColumns) {
    x += "_" + allColumns.indexOf(column);
  }
  return x.replace(/\s+/g, "_");
}
let isRefreshing = false;
let refreshQueued = false;
async function refresh() {
  // Re-Entrancy-Schutz: onClose der Edit-Dialoge feuert nach dem Speichern
  // mehrfach (mehrere emit("back") -> mehrere setTimeout(refresh)). Ohne diesen
  // Guard wird die Grid-Query dadurch (und via Render-Churn) hunderte Male abgesetzt.
  if (isRefreshing) {
    refreshQueued = true;
    return;
  }
  isRefreshing = true;
  captureOpenGroups();
  resetGroupHeaders();
  selected.value = [];
  try {
    if (props.preloadedData) {
      if (treeviewMutable) {
        const tempData: any = props.preloadedData.data;
        dataLoaded(tempData);
      } else {
        dataLoaded(props.preloadedData);
      }
    } else if (props.queryData) {
      dataLoaded(props.queryData);
    } else if (props.query ?? props.siteData?.query) {
      const response = await AUApi.Current.getQuery(
        props.query ?? props.siteData?.query,
        undefined,
        props.queryAic ?? props.siteData?.aic,
        lokalZeitbereich.value,
      );
      if (response) {
        dataLoaded(response.data);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    addDruck();
    showLoading.value = false;
    initialized.value = true;
    isRefreshing = false;
    if (refreshQueued) {
      // genau EIN gecoalescter Nachlauf, falls waehrend des Ladens ein
      // weiterer Reload angefordert wurde - kein Aufschaukeln.
      refreshQueued = false;
      setTimeout(() => refresh());
    }
  }
}
let expandDataSet!: QueryResponse;

async function loadDetails(item: number) {
  if (item) {
    showLoadingSub.value = true; // nicht alles ausblenden nur ein loading für den subblock
    try {
      if (expandQuery) {
        const aic = item;
        mainprintItems = props.printItems ?? [];
        mainAicInternal = aic ?? props.mainAic;
        mainSttInternal = header.aicStt ?? 0; // mainStt = Stammtyp auf den gespeichert werden soll
        const response = await AUApi.Current.getQuery(
          expandQuery,
          undefined,
          aic,
          lokalZeitbereich.value,
        );
        if (response && response.data) {
          const dataExpand = response.data;
          const colsExpand = dataExpand.columns.filter(
            (c) => !c.meta.invisible && !c.meta.banned,
          );
          expandDataSet = dataExpand;
          // if (dataExpand) { isExpandDataSetLoaded = true; }
          // else { isExpandDataSetLoaded = false; }
          showLoadingSub.value = false;
        }
        return "no data found";
      }
    } finally {
      showLoadingSub.value = false;
    }
  }
}

function newItem() {
  let mehrfach = false;
  if (header.tabellenTyp === "Mehrfach") {
    // bei Mehrfach Tabellen, zB Firmenkonto - muss ich den führenden Stammsatz mitgeben, damit darauf gespeichert werden kann

    mehrfach = true;
  }
  if (
    subQuery &&
    (dialog.componentName === "None" || !dialog.componentName) &&
    (newDialog.componentName === "None" || !newDialog.componentName)
  ) {
    dialog.query = subQuery;
    if (header.aicBew) {
      // dialog.aic = mainAicInternal;
      // dialog.aic = undefined;
      dialog.aic = mainAicInternal;
      dialog.mainAic = mainAicInternal;
      dialog.mainStt = mainSttInternal;
      dialog.bewegungsdaten = false;
      // wenn es um SubData geht - dann muss ich den führenden AIC übergeben!
    } else {
      dialog.aic = undefined;
      if (mehrfach) {
        dialog.aic = mainAicInternal;
      }

      dialog.mehrfach = mehrfach;
    }
    dialog.newData = true;
    dialogOpen.value = true;
  } else if (dialog.showCustomEditor || newDialog.showCustomEditor) {
    const editZeitbereich = lokalZeitbereich.value;
    const aic = 0;
    let mainAic = 0;
    let bewegungsdaten = false;
    let newData = true;
    const updateData = undefined;
    if (header.aicBew) {
      mainAic = mainAicInternal;
      bewegungsdaten = true;
    }
    const navData = {
      zeitbereich: editZeitbereich,
      aic,
      bewegungsdaten,
      reloadData: false,
      mainAic,
      newData,
      mehrfach,
      editQuery: newDialog.query ?? dialog.query,
      updateData,
    };
    let handledClose = false;
    let fullscreen = false;
    if (isMobile.value || dialog.fullscreen) {
      fullscreen = true;
    }
    if (
      header.aicBew ||
      !dialog.stammQuery ||
      (newDialog && !newDialog.stammQuery)
    ) {
      showDialog({
        title:
          newDialog.title && newDialog.title !== "--!!--"
            ? newDialog.title
            : dialog.title,
        site:
          newDialog.componentName && newDialog.componentName !== "None"
            ? newDialog.componentName
            : dialog.componentName,
        data: navData,
        fullscreen,
        width: 400,
        onClose: () => {
          if (handledClose) {
            return true;
          }
          handledClose = true;
          if (navData.reloadData) {
            lokalZeitbereich.value = { ...editZeitbereich };
            if (navData.aic && navData.updateData) {
              onBack(navData.updateData);
            } else setTimeout(() => refresh());
          }

          return true;
        },
      });
    } else {
      showDialog({
        showTitle: false,
        title:
          newDialog.title && newDialog.title !== "--!!--"
            ? newDialog.title
            : dialog.title,
        site:
          newDialog.componentName && newDialog.componentName !== "None"
            ? newDialog.componentName
            : dialog.componentName,
        data: navData,
        fullscreen: true,
        onClose: () => {
          if (handledClose) {
            return true;
          }
          handledClose = true;
          lokalZeitbereich.value = { ...editZeitbereich };
          setCompKeyZeitraum.value += +1;
          if (navData.reloadData) {
            lokalZeitbereich.value = { ...editZeitbereich };
            if (navData.aic && navData.updateData) {
              onBack(navData.updateData);
            } else setTimeout(() => refresh());
          }
          return true;
        },
      });
    }
  }
}
function editItem(item: any) {
  if (item) {
    console.log(item);
  }
  if (editAbf) {
    dialog.query = editAbf;
  }
  dialog.aic = item.aic_Stamm ?? item.aic_Bew_pool;
  const aic = item.aic_Stamm ?? item.aic_Bew_pool;
  const selectedId = Number(
    item?.[rowKey.value] ??
      item?.aic_Stamm ??
      item?.aic_Bew_pool ??
      item?.aic ??
      0,
  );
  if (selectedId > 0) {
    // rowSelect() ändert selectedRow, das Teil des :key der v-data-table ist (für die
    // Zeilen-Hervorhebung) - das erzwingt einen Remount der Tabelle, der Vuetifys internen
    // "Gruppe offen"-Zustand zurücksetzt. Gleiches Capture/Restore wie beim Datenreload in
    // refresh() nötig, damit offene Gruppen beim Öffnen der Editmaske offen bleiben.
    captureOpenGroups();
    selected.value = [selectedId];
    rowSelect(selectedId);
    if (showGroupBy.value) {
      nextTick(() => {
        setTimeout(() => restoreOpenGroups(), 100);
      });
    }
  }
  if (item.aic_Bew_pool && dialog.aic) {
    selectedAic = dialog.aic;
    dialog.mainAic = mainAicInternal;
    dialog.mainStt = mainSttInternal;
    dialog.bewegungsdaten = true;
  }
  if (dialog.abwAic) {
    const key = dialog.abwAic;
    const gridrow = rowdata.find(
      (row: any) => row.aic_Bew_pool === item.aic_Bew_pool,
    );
    const column = allColumns.find((col: any) => col.name === key);
    if (column && gridrow) {
      try {
        const abwAic = getValue(gridrow, column);
        dialog.aic = abwAic;
      } catch (ex) {
        console.log(ex);
      }
    }
  }
  dialog.newData = false;
  const editZeitbereich = lokalZeitbereich.value;
  if (
    dialog.query &&
    (!dialog.componentName || dialog.componentName === "None")
  ) {
    dialogOpen.value = true;
  } else {
    if (dialog.keinZeitraum) {
      // ich geh auf 2 Jahre in die vergangenheit - dann sollten alle Daten da sein..
      let von = lokalZeitbereich.value.von;
      von = von.addMonths(-24, true);
      editZeitbereich.von = von;
      // zeitbereich auf offen stellen??
    }
    const updateData = undefined;
    const navData = {
      zeitbereich: editZeitbereich,
      aic,
      bewegungsdaten: dialog.bewegungsdaten,
      onReloadData: false,
      auswahlQuery: dialog.auswahlQuery,
      stammQuery: dialog.stammQuery,
      neuDialog: dialog.neuDialog,
      editQuery: dialog.query,
      reloadData: false,
      updateData,
    };
    let fullscreen = false;
    if (isMobile.value || dialog.fullscreen) {
      fullscreen = true;
    }
    // openSubPage(dialog.componentName, dialog.title, navData);
    // onClose kann nach dem Speichern mehrfach anlaufen (mehrere emit("back")
    // aus onSave + saved()) - Guard wie in newItem(), damit nur EIN Reload erfolgt.
    let handledClose = false;
    const handleEditClose = () => {
      if (handledClose) {
        return true;
      }
      handledClose = true;
      lokalZeitbereich.value = { ...editZeitbereich };
      setCompKeyZeitraum.value += +1;
      if (navData.aic && navData.updateData) {
        onBack(navData.updateData);
      } else setTimeout(() => refresh());
      return true;
    };
    if (dialog.bewegungsdaten || !dialog.stammQuery) {
      // RkMitarbeiterBeleg (KI-Belegerkennung) braucht wegen der 2-spaltigen Anzeige mehr Platz.
      // Anhand componentName statt dialog.query prüfen, da die editAbf-Query grid-weit geteilt
      // wird und sonst auch andere Dialoge (z.B. DialogSonstigeBelege) fälschlich 700 bekommen.
      const width = dialog.componentName === "RkMitarbeiterBeleg" ? 800 : 400;
      showDialog({
        title: dialog.title,
        site: dialog.componentName,
        data: navData,
        fullscreen,
        width,
        onClose: handleEditClose,
      });
    } else {
      showDialog({
        showTitle: false,
        title: dialog.title,
        site: dialog.componentName,
        data: navData,
        fullscreen: true,
        onClose: handleEditClose,
      });
    }
  }
}
function deleteItemDialog(item: any) {
  aic = item.aic_Stamm ?? item.aic_Bew_pool;
  dialogDelete.value = true;
}
function copyItemDialog(item: any) {
  aic = item.aic_Stamm ?? item.aic_Bew_pool;
  dialogCopy.value = true;
}
function deleteItem(item: any) {
  if (!aic) {
    showSnackbar("keinen Datensatz übergeben!");
    return;
  }
  AUApi.Current.DeleteData(
    header,
    aic,
    0,
    lokalZeitbereich.value,
    false,
    (res: any) => {
      const msgType = res.data.msgType;
      let info = res.data.info;
      const tabInfo = res.data.tab;
      const memo = res.data.memo;
      const title = res.data.titel;
      if (memo) {
        info = memo;
      }
      if (tabInfo) {
        const typ = tabInfo[0].Bewegungstyp;
        const anzahl = tabInfo[0].Anzahl;
        const table = tabInfo;
      }
      if (info) {
        if (msgType === "Error") {
          showSnackbar({
            text: info,
            color: "error",
          });
        } else if (msgType === "Info") {
          showSnackbar({
            text: info,
            color: "info",
          });
        } else if (msgType === "Warnung") {
          showSnackbar({
            text: info,
            color: "warning",
            table: tabInfo,
          });
        }
        showLoading.value = false;
        return msgType;
      }
      deleteRow();
      showSnackbar(
        globalsBegriffMemo(
          Globals.Begriff,
          "Datensatz_geloescht",
          "Daten wurden gelöscht",
        ),
      );
    },
    (ex: any) => {
      const msgType = ex.response.data.msgType;
      let errorMessage = "";
      if (ex.response) {
        errorMessage = ex.response.data.error;
        if (!errorMessage) {
          errorMessage = ex.response.data.info;
        }
      } else {
        errorMessage = ex;
      }
      showSnackbar({
        text: errorMessage,
        color: "error",
      });
      showLoading.value = false;
      return msgType;
      // console.log(ex);
      // alert("Entschuldigung es ist ein Fehler beim Löschen aufgetreten");
    },
  );
  dialogDelete.value = false;
  showLoading.value = true;
}

function copyItem() {
  const varUbergabe: VarUebergabe[] = [];
  calcFunctionNew(calcModell, aic, false, onCalculated, "", varUbergabe)
    .then((response: any) => {
      if (response !== "Error") {
        onBack(response);
      }
    })
    .catch((error: any) => {
      // hübsche Fehlerbehandlung
      showSnackbar({
        text: error,
        color: "error",
      });
      console.log("ModellError:" + error);
    });
  dialogCopy.value = false;
}
async function copyStamm() {
  const response = await AUApi.Current.copyStamm(aic);
  dialogCopy.value = false;
  if (response?.data.copyStamm) {
    const bezeichnung = response.data.copyBez;
    refresh();
  }
}
function closeDelete() {
  dialogDelete.value = false;
}
function closeCopy() {
  dialogCopy.value = false;
}

function openVerwendung(item: any) {
  dialog.query = subAbf;
  dialog.aic = undefined;
  dialog.mainAic = item.aic_Stamm;
  dialog.mainStt = 0;
  dialog.bewegungsdaten = true;
  dialogVerwendung.value = true;
  dialog.printItems = [];
  dialog.width = innerWidth;
  dialog.height = 800;
}
function dataLoaded(data: QueryResponse) {
  try {
    noData.value = false;
    lastQueryResponse = data;
    rowdata = [data.data];
    header = data.header;
    if (header?.ZR_Wahl === true) {
      showZeitraum.value = true;
    }
    // if (header.aicBew && header?.ZR_Wahl === true) {
    //   showZeitraum.value = true;
    // }
    if (header?.keinNeu) {
      showNew.value = false;
    }
    // es soll auch über eine Spalte gesteuert werden können ob NEU möglich ist!
    const findnoNew = data.columns.filter((c) => c.meta.kz === "noNew");
    if (findnoNew && findnoNew.length > 0) {
      const row = rowdata[0];
      const valueShowNow = getValue(row[0], findnoNew[0]);
      if (valueShowNow) {
        showNew.value = false;
      }
    }
    if (header?.gleich) {
      letzteDatenAnzeigen = true;
    }
    const editForm: any = data.columns.filter(
      (c) => c.datatype === "Formular" && c.meta.kz === "edit",
    );
    let editDetail: any;
    if (editForm.length === 0) {
      if (header.fomDetail) {
        editForm.push(header.fomDetail);
        editDetail = header.fomDetail;
        dialogEdit.value = true;
      }
    } else if (editForm[0] && editForm[0].meta && editForm[0].meta.subFom) {
      editDetail = editForm[0].meta?.subFom[0];
      dialogEdit.value = true;
      if (header.fomDetail) {
        newDialog.componentName =
          header.fomDetail.alias ?? header.fomDetail.kennung;
        newDialog.title = header.fomDetail.bezeichnung;
        newDialog.showCustomEditor = true;
        newDialog.fullscreen = header.fomDetail.fullScreen ?? false;
        newDialog.width = window.innerWidth;
        newDialog.height = window.innerHeight;
        newDialog.keinZeitraum = header.fomDetail.keinZR;
        newDialog.stammQuery = header.fomDetail.stammQuery;
        newDialog.neuDialog = header.fomDetail.neuDialog;
        newDialog.auswahlQuery = header.fomDetail.auswahlQuery;
      }
    }
    if (editDetail && editForm!.length > 0) {
      if (!dialogInlineEdit.value) {
        dialogInlineEdit.value = true;
        headers.value.push({
          title: "",
          key: "action",
          sortable: false,
        });
      }
      dialog.componentName = editDetail.alias ?? editDetail.kennung;
      dialog.title = editDetail.bezeichnung;
      dialog.showCustomEditor = true;
      dialog.fullscreen = editDetail.fullScreen ?? false;
      dialog.width = window.innerWidth;
      dialog.height = window.innerHeight;
      dialog.keinZeitraum = editDetail.keinZR;
      dialog.stammQuery = editDetail.stammQuery;
      dialog.neuDialog = editDetail.neuDialog;
      dialog.auswahlQuery = editDetail.auswahlQuery;
      if (editForm[0].meta?.subSpalte) {
        dialog.abwAic = editForm[0].meta?.subSpalte;
      }
    }
    let editAbfLocal: any = data.columns.filter(
      (c) => c.datatype === "Abfrage" && c.meta.kz === "edit",
    );
    const details = header?.abfDetail;
    if (details) {
      subQuery = details;
      dialog.query = details;
    }
    if (editAbfLocal!.length > 0) {
      if (!dialogInlineEdit.value) {
        headers.value.push({
          title: "",
          key: "actions",
          sortable: false,
          align: "end",
        });
      }
      const editAbfDetail = editAbfLocal[0].meta;
      editAbf = editAbfDetail.subAbf[0].kennung;
    } else if (subQuery) {
      editAbf = subQuery;
    }
    if (header.keinBez) {
      bezeichnung.value = "";
      showBezeichnung.value = false;
    } else {
      bezeichnung.value = header.bezeichnung;
      showBezeichnung.value = true;
    }
    if ((data.data?.length ?? 0) === 0) {
      disableFooter.value = true;
      noData.value = true;
      tableData.value = []; // keine Daten: gerenderte Zeilen leeren (auch bei Reload nach Löschen)
      // props.mainStt = data.header.aicStt;

      if (header?.DialogEdit) {
        const abfDetails = header?.abfDetail;
        if (abfDetails) {
          subQuery = abfDetails;
          dialogEdit.value = true;
        }
        if (header.fomDetail) {
          let editNew: any;
          editNew = header.fomDetail;
          dialogEdit.value = true;
          dialog.componentName = editNew.alias ?? editNew.kennung;
          dialog.title = editNew.bezeichnung;
          dialog.showCustomEditor = true;
          dialog.keinZeitraum = editNew.keinZR;
          dialog.fullscreen = editNew.fullScreen ?? false;
        }
      }
      return;
    } else if (data.data.length > pageSize.value) {
      disableFooter.value = false;
    }
    if (props.onlyVector || header.multi) {
      showSelect.value = true;
    }
    const id = header.aicBew ?? header.aicStt;
    if (header.aicBew && props.printItems && props.printItems.length > 0) {
      mainprintItems = props.printItems.filter(
        (c: any) => c.bew === id || c.stt === id,
      );
    }
    if (props.exportItems && props.exportItems.length > 0) {
      // nur die Abfragen die auch zur Bewegung / Stamm passen anzeigen!

      mainexportItems = props.exportItems.filter(
        (c: any) => c.bew === id || c.stt === id,
      );
      showSelect.value = true;
    }
    if (data.data[0] && data.data[0].aic) {
      rowKey.value = "aic";
    } else if (data.data[0] && data.data[0].aic_Stamm) {
      rowKey.value = "aic_Stamm";
    } else if (data.data[0] && data.data[0].aic_Bew_pool) {
      rowKey.value = "aic_Bew_pool";
    }
    const webStamm = header?.webStamm; // webStamm = definitin bei der Abfrage!
    if (webStamm) {
      if (aufgabenDefinition) {
        const stamm = aufgabenDefinition?.data.find(
          (r: any) => r.aic_Stamm === webStamm,
        );
        if (stamm) {
          showCopyStamm = getKZAufgabeDefiniton(
            "stammKopie",
            stamm.aic_Stamm,
            aufgabenDefinition,
          );
        }
      }
    }
    const erweitert = header?.abfErweitert;
    if (erweitert) {
      expandQuery = erweitert;
    }
    if (expandQuery) {
      showExpand.value = true;
    }

    showSearch.value = header?.suche ?? false;
    allColumns = data.columns;
    const dataTable = data.data;

    defColums = data.columns.filter(
      (c) => c.meta.kz === "allowDelete" || c.kennung === "NOCHANGE",
    );
    const cols = data.columns.filter(
      (c) => !c.meta.invisible && !c.meta.banned,
    );
    visibleColumns = cols;
    checkboxColumns.value = cols.filter((c) => c.type === "checkBox");
    ampelColumns.value = cols.filter((c) => c.type === "ampel");
    // columnsforGroupSummary = visibleColumns.filter((c) => !c.meta.gruppierbar);
    const colsSelect = data.columns.filter((c) => c.meta.kz === "select");
    const sysTable = data.columns.filter((c) => c.datatype === "SysAic");
    if (header?.DialogEdit) {
      showDialogLocal = true;
      dialogInlineEdit.value = true;
      dialogEdit.value = true;
      if (!header.keinDel) {
        // kein Löschen - Parameter bei Abfrage
        showDelete.value = true;
      }
    }
    let maxPercent = 0;
    headers.value = cols
      .filter((c) => c.meta.gruppiert !== true) // Gruppierte Spalten ausfiltern
      .map((c) => {
        let alignText: any = "start";
        let widthValue: number | string | undefined = c.meta?.webWidth;
        if (
          !isMobile.value &&
          (c.type === "zahl" || c.type === "waehrung" || c.type === "mass")
        ) {
          alignText = "end";
          widthValue = widthValue ?? 100;
        } else if (c.type === "checkBox") {
          alignText = "start";
        }
        if (widthValue) {
          maxPercent = maxPercent + toNumber(widthValue);
        } else {
          if (c.type === "fileChoicer") {
            widthValue = 300;
            maxPercent = maxPercent + 50;
          }
          // else if (c.type === "datePicker") {
          //   c.meta.webWidth = 50;
          //   maxPercent = maxPercent + 10;
          // }
          else {
            maxPercent = maxPercent + 20;
          }
        }
        return {
          title: c.title,
          key: c.name,
          align: alignText,
          queryColumn: c,
          groupable: c.meta.gruppierbar === true,
          type: c.type,
          width: widthValue ?? "20%",
          sortable: true,
        };
      });

    // Mobile-Optimierung: Spaltenbreiten reduzieren, damit sie in 430px passen
    if (isMobile.value && maxPercent > 100) {
      const scaleFactor = 100 / maxPercent;
      headers.value = headers.value.map((h) => {
        const w = h.width;
        if (typeof w === "number" && w > 0) {
          return { ...h, width: Math.max(40, Math.floor(w * scaleFactor)) };
        }
        return h;
      });
    }

    // Reihenfolge vom Server beibehalten: keine lokale Sortierung erzwingen
    sortBy.value = [];

    const groupedColumns = cols
      .filter((c) => c.meta.gruppiert === true)
      .sort((a: any, b: any) => {
        const aSort =
          typeof a?.meta?.sortiert === "number"
            ? Math.abs(a.meta.sortiert)
            : 9999;
        const bSort =
          typeof b?.meta?.sortiert === "number"
            ? Math.abs(b.meta.sortiert)
            : 9999;
        return aSort - bSort;
      });

    const groupedKeyByColumn: Record<string, string> = {};
    groupedColumns.forEach((c) => {
      groupedKeyByColumn[c.name] = `__group_${c.name}`;
    });

    groupedBy.value = groupedColumns.map((c: any) => ({
      key: groupedKeyByColumn[c.name] ?? c.name,
      order: "asc",
    }));
    showGroupBy.value = groupedBy.value.length > 0;

    if (showGroupBy.value) {
      nextTick(() => {
        setTimeout(() => {
          if (openedGroupValues.value.size > 0) {
            restoreOpenGroups();
          } else {
            toggleAllGroups(true);
          }
        }, 100);
      });
    }

    if (dialogInlineEdit.value) {
      if (maxPercent > 100) {
        maxPercent = 70;
      }
      const widthBtn = 100 - maxPercent;
      const widthString = widthBtn.toString() + "%";
      headers.value.push({
        title: "",
        key: "actions",
        sortable: false,
        width: widthString,
        align: "end",
      });
    }
    let calcModellLocal = data.columns.filter((c) => c.datatype === "Modell");
    if (calcModellLocal!.length > 0) {
      if (!dialogInlineEdit.value) {
        headers.value.push({
          title: "",
          key: "actions",
          sortable: false,
          align: "end",
        });
      }
      showCopy = true;
      const subMod = calcModellLocal[0].meta;
      if (subMod && subMod.subMod) {
        calcModell = subMod.subMod[0].kennung;
      }
    }
    const subAbfLocal = data.columns.filter(
      (c) => c.datatype === "Abfrage" && c.meta.kz === "use",
    );
    if (subAbfLocal!.length > 0) {
      if (!dialogInlineEdit.value) {
        headers.value.push({
          title: "",
          key: "actions",
          sortable: false,
          align: "end",
        });
      }
      showVerwendung = true;
      const subAbfDetail = subAbfLocal[0].meta;
      if (subAbfDetail && subAbfDetail.subAbf) {
        subAbf = subAbfDetail.subAbf[0].kennung;
      }
    }

    colorColumn = getKZColumn("color", data.columns);
    aggregateColumns = data.columns.filter(
      (c: any) =>
        c.meta.ergebnisArt !== undefined && c.meta.ergebnisArt !== null,
    );

    // groupedBy.value = data.columns
    //   .filter(c => c.meta.gruppiert === true)
    //   .map(c => c.name);

    // hier nur dateninhalte kein styling
    // tableData = data.data;
    const groupOrderIndexByColumn: Record<string, Record<string, number>> = {};
    groupedColumns.forEach((c) => {
      groupOrderIndexByColumn[c.name] = {};
    });
    groupValueLabelMap.value = {};

    tableData.value = data.data.map((row: any) => {
      const tr: any = {};
      tr.aic = row.aic;
      tr.aic_Stamm = row.aic_Stamm;
      tr.aic_Bew_pool = row.aic_Bew_pool;

      groupedColumns.forEach((groupCol) => {
        const groupLabel = String(getDisplay(row, groupCol) ?? "");
        const colOrderMap = groupOrderIndexByColumn[groupCol.name];
        if (colOrderMap[groupLabel] === undefined) {
          colOrderMap[groupLabel] = Object.keys(colOrderMap).length + 1;
        }
        const syntheticKey = `${String(colOrderMap[groupLabel]).padStart(
          6,
          "0",
        )}__${groupLabel}`;
        tr[groupedKeyByColumn[groupCol.name]] = syntheticKey;
        groupValueLabelMap.value[syntheticKey] = groupLabel;
      });

      visibleColumns.forEach((col) => {
        if (col.type === "ampel") {
          tr[col.name] = getValue(row, col);
        } else if (col.type === "checkBox") {
          tr[col.name] = Boolean(getValue(row, col));
        } else {
          tr[col.name] = getDisplay(row, col);
        }
      });
      sysTable.forEach((col) => {
        tr[col.name] = getDisplay(row, col);
      });
      if (defColums.length > 0) {
        showDelete.value = false;
        showDeleteDetail = true;
        defColums.forEach((col) => {
          if (col.kennung === "NOCHANGE") {
            const noChange = getValue(row, col);
            tr.allowDelete = !noChange;
          } else {
            tr.allowDelete = getValue(row, col);
          }
        });
      }
      return tr;
    });
    // eine künstliche Summenzeile erzeuigen - da sonst die breiten nicht passen
    // if (aggregateColumns.length > 0) {
    //   const sumRow: Record<string, any> = {};
    //   sumRow["aic_Bew_pool"] = -1;
    //   const data = visibleColumns.forEach((col) => {
    //     const rowProp: any = col.name;
    //     if (
    //       col.meta.ergebnisArt !== undefined &&
    //       col.meta.ergebnisArt !== null
    //     ) {
    //       let val = getGroupSumValue(lastQueryResponse.data, col);
    //       val = getDisplayValue(val, col);

    //       sumRow[rowProp] = val;
    //     } else {
    //       sumRow[rowProp] = "";
    //     }
    //   });
    //   tableData.value = [...tableData.value, sumRow];
    // }
    // Zeilen Vorselektieren! KZ bei Column = "select"
    if (colsSelect && colsSelect.length > 0) {
      data.data.forEach((row: any) => {
        const col = row[colsSelect[0].name];
        if (col) {
          selected.value.push(row.aic_Bew_pool ?? row.aic_Stamm ?? 0);
        }
      });
    }
  } catch (error) {
    console.error(error);
  } finally {
    if (props.preSelectedRow) {
      const gridrow = tableData.value.find(
        (x: any) => x.aic_Stamm === props.preSelectedRow,
      );
      // selected muss ein AIC sein... nochmal testen!
      // selected.value.push(gridrow.aic);
      rowSelect(props.preSelectedRow);
    }
    showLoading.value = false;
    initialized.value = true;
    const init = true;
    emit("loaded", init);
  }
}
function getAmpelColor(code: number | null | undefined) {
  if (code === 1) return "green";
  if (code === 2) return "orange";
  if (code === 3) return "red";
  return "grey";
}
function itemRowBackground(wrapper: any) {
  const item = wrapper?.raw ?? wrapper?.item ?? wrapper;
  if (!item) {
    return "";
  }
  const classes: string[] = [];
  if (item.id === -1) {
    classes.push("bg-gray-100");
  } else if (item.colorColumn) {
    classes.push(item.colorColumn);
  }

  const key = rowKey.value;
  const matchesSelectedRow =
    item[key] === selectedRow.value ||
    item.aic_Stamm === selectedRow.value ||
    item.aic_Bew_pool === selectedRow.value ||
    item.aic === selectedRow.value;
  if (selectedRow.value && matchesSelectedRow) {
    classes.push("rowSelected");
  }

  return classes.join(" ");
}
function rowProps(item: any) {
  return { class: itemRowBackground(item) };
}
function getRowStyle(rowIndex: number) {
  if (!colorColumn && aggregateColumns.length === 0) {
    if (rowIndex === selectedRow.value) {
      return { backgroundColor: "grey" };
    } else {
      return;
    }
  }
  const row = lastQueryResponse?.data[rowIndex];
  if (colorColumn) {
    const color = getValue(row, colorColumn);
    return { backgroundColor: color };
  }
  return { backgroundColor: "grey" };
}
function getColStyle(c: DataColumn) {
  const align =
    c.type === "zahl" || c.type === "waehrung" || c.type === "mass"
      ? "right"
      : "left";
  let width = c.meta?.webWidth;
  if (
    !isMobile.value &&
    !width &&
    (c.type === "zahl" || c.type === "waehrung" || c.type === "mass")
  ) {
    width = 100;
  }
  // Mobile: Spaltenbreiten skalieren
  if (isMobile.value && width && typeof width === "number" && width > 80) {
    width = Math.max(40, Math.floor(width * 0.65));
  }
  if (width) {
    return `text-align: ${align}; width: ${width}px; min-width: ${width}px; max-width: ${width}px;`;
  }
  return `text-align: ${align};`;
}

function getHeaderStyle(c: DataColumn) {
  const align =
    c.type === "checkBox"
      ? "center"
      : c.type !== "zahl" && c.type !== "waehrung" && c.type !== "mass"
        ? "left"
        : "right";
  let width = c.meta?.webWidth;
  if (
    !isMobile.value &&
    !width &&
    (c.type === "zahl" || c.type === "waehrung" || c.type === "mass")
  ) {
    width = 100;
  }
  // Mobile: Spaltenbreiten skalieren
  if (isMobile.value && width && typeof width === "number" && width > 80) {
    width = Math.max(40, Math.floor(width * 0.65));
  }
  if (width) {
    return `text-align: ${align} !important; width: ${width}px; min-width: ${width}px; max-width: ${width}px;`;
  }
  return `text-align: ${align} !important;`;
}
function getFooter(col: DataColumn) {
  // Prüfe auf Namensgleichheit statt Referenzgleichheit
  if (
    !lastQueryResponse ||
    !aggregateColumns.find((c) => c.name === col.name)
  ) {
    return;
  }

  const val = getGroupSumValue(lastQueryResponse.data, col);
  return getDisplayValue(val, col);
}
function getSubTotal(col: DataColumn, items: any) {
  // Namensgleichheit statt Referenzgleichheit - col-Objekte werden bei jedem refresh() neu erzeugt
  if (
    !lastQueryResponse ||
    !aggregateColumns.find((c) => c.name === col.name)
  ) {
    return;
  }
  const collectLeafRows = (groupItems: any[]): any[] => {
    const rows: any[] = [];
    const walk = (entries: any[]) => {
      entries?.forEach((entry) => {
        if (!entry) return;
        if (Array.isArray(entry.items)) {
          walk(entry.items);
          return;
        }
        rows.push(entry.raw ?? entry.item ?? entry);
      });
    };
    walk(groupItems ?? []);
    return rows;
  };

  const leafRows = collectLeafRows(items ?? []);
  const sum = leafRows.reduce((total: number, row: any) => {
    const raw = row?.[col.name] ?? row?.columns?.[col.name] ?? 0;
    const value = normalizeNumber(raw);
    return total + (value ?? 0);
  }, 0);

  return getDisplayValue(sum, col);
}

function getGroupHeaderLabel(value: any): string {
  const key = String(value ?? "");
  return groupValueLabelMap.value[key] ?? key.replace(/^\d+__/, "");
}
function onBack(updateData: any, reload?: boolean, aicOld?: number) {
  showLoading.value = true;
  if (updateData) {
    emit("onReloadData");
    let newData = false;
    // updateData kann ein Array (z.B. [obj]) oder direkt ein Objekt sein
    const data = Array.isArray(updateData) ? updateData[0] : updateData;
    if (!header.aicBew) {
      let rawGridRow: QueryDataRow | undefined =
        data?.aic_Stamm != null
          ? lastQueryResponse?.data?.find(
              (row: QueryDataRow) => row.aic_Stamm === data.aic_Stamm,
            )
          : undefined;
      let rawNewData = false;
      if (!rawGridRow) {
        rawGridRow = data;
        rawNewData = true;
      }
      let gridrow: QueryDataRow | undefined =
        data?.aic_Stamm != null
          ? tableData.value.find(
              (row: QueryDataRow) => row.aic_Stamm === data.aic_Stamm,
            )
          : undefined;
      if (!gridrow) {
        gridrow = data;
        newData = true;
      }
      if (data && gridrow) {
        for (const key of Object.keys(data)) {
          if (
            key !== "aic_Stamm" &&
            key !== "aic_mandant" &&
            key !== "noChange"
          ) {
            const column = allColumns.find((col: any) => col.name === key);
            if (column) {
              try {
                const rowProp: any = column.name;
                gridrow[rowProp] = getDisplayValue(data[key], column);
                if (rawGridRow) {
                  rawGridRow[rowProp] = data[key];
                }
                gridrow.allowDelete = true;
              } catch (ex) {
                console.log(ex);
              }
            }
          }
        }
        if (newData && gridrow) {
          // allowDelete analog wie bei Initialisierung setzen
          if (defColums && defColums.length > 0 && gridrow) {
            defColums.forEach((col: DataColumn) => {
              if (!gridrow) return;
              if (col.kennung === "NOCHANGE") {
                const noChange = getValue(gridrow, col);
                gridrow.allowDelete = !noChange;
              } else {
                gridrow.allowDelete = getValue(gridrow, col);
              }
            });
          }
          tableData.value.push(gridrow);
          sortData();
        }
        if (rawNewData && rawGridRow && lastQueryResponse?.data) {
          lastQueryResponse.data.push(rawGridRow);
          tableData.value = [...tableData.value]; // datasource refreshen für grid
        } else {
          refresh();
        }
      }
    } else {
      let gridrowBew: QueryDataRow | undefined;
      const targetId = selectedAic ?? aicOld ?? data?.aic_Bew_pool;
      let rawGridrowBew: QueryDataRow | undefined;
      if (targetId != null) {
        gridrowBew = tableData.value.find(
          (row: QueryDataRow) => row.aic_Bew_pool === targetId,
        );
        rawGridrowBew = lastQueryResponse?.data?.find(
          (row: QueryDataRow) => row.aic_Bew_pool === targetId,
        );
      }
      let rawNewData = false;
      if (!rawGridrowBew) {
        rawGridrowBew = data;
        rawNewData = true;
      }
      if (!gridrowBew) {
        gridrowBew = data;
        newData = true;
      }
      if (data && gridrowBew) {
        // allowDelete analog wie bei Initialisierung setzen
        if (defColums && defColums.length > 0 && gridrowBew) {
          defColums.forEach((col: DataColumn) => {
            if (!gridrowBew) return;
            if (col.kennung === "NOCHANGE") {
              const noChange = getValue(data, col);
              gridrowBew.allowDelete = !noChange;
            } else {
              gridrowBew.allowDelete = getValue(data, col); // aus neuen gespeicherten Werten den inhalt holen
            }
          });
        }
        for (const key of Object.keys(data)) {
          const column = allColumns.find((col: any) => col.name === key);
          if (column) {
            try {
              const rowProp: string = column.name;
              gridrowBew[rowProp] = getDisplayValue(data[key], column);
              if (rawGridrowBew) {
                rawGridrowBew[rowProp] = data[key];
              }
            } catch (ex) {
              console.log(ex);
            }
          }
        }
        if (newData && gridrowBew) {
          const wasEmpty = tableData.value.length === 0;
          tableData.value.push(gridrowBew);
          // Spalten initialisieren, falls Tabelle vorher leer war
          if (
            wasEmpty &&
            Array.isArray(allColumns) &&
            allColumns.length === 0 &&
            gridrowBew
          ) {
            refresh(); // neu laden -da die Columns nichts aufgebaut ist!
          }
          sortData();
        }
        if (rawNewData && rawGridrowBew && lastQueryResponse?.data) {
          lastQueryResponse.data.push(rawGridrowBew);
        }
        tableData.value = [...tableData.value]; // datasource refreshen für grid
      }
    }
  }
  emit("back");
  emit("onReloadData");
  const focusId = Number(
    updateData?.[rowKey.value] ??
      updateData?.aic_Stamm ??
      updateData?.aic_Bew_pool ??
      updateData?.aic ??
      0,
  );
  if (focusId > 0) {
    if (showSelect.value) {
      selected.value = [focusId];
    }
    rowSelect(focusId);
  }
  showLoading.value = false;
  dialogOpen.value = false;
}
function dialogBack() {
  dialogVerwendung.value = false;
}

function sortData() {
  // Spalten nach meta.sortiert (1,2,3,...) sammeln und nach Priorität sortieren
  const sortCols = allColumns
    .filter((col: any) => typeof col?.meta?.sortiert === "number")
    .sort(
      (a: any, b: any) =>
        (a.meta.sortiert as number) - (b.meta.sortiert as number),
    );

  if (!sortCols.length) return;

  const comparator = (a: any, b: any) => {
    for (const col of sortCols) {
      const key = col.name;
      const dir = getSortDirection(col); // 'asc' | 'desc'
      const av = a[key];
      const bv = b[key];
      const res = compareValuesByColumn(av, bv, col);
      if (res !== 0) return dir === "desc" ? -res : res;
    }
    return 0;
  };

  tableData.value.sort(comparator);
}
function rowSelect(idx: number) {
  const selectedId = Number(idx);
  if (!selectedId) {
    return { backgroundColor: "grey" };
  }

  selectedRow.value = selectedId;
  const selectedIndex = tableData.value.findIndex((row: any) => {
    const rowId = Number(
      row?.[rowKey.value] ??
        row?.aic_Stamm ??
        row?.aic_Bew_pool ??
        row?.aic ??
        0,
    );
    return rowId === selectedId;
  });

  if (selectedIndex >= 0 && pageSize.value > 0) {
    const targetPage = Math.floor(selectedIndex / pageSize.value) + 1;
    if (page.value !== targetPage) {
      page.value = targetPage;
    }
  }
  const scrollToSelectedRow = (attempt = 0) => {
    const tableRoot = document.querySelector(".v-data-table");
    const selectedElement = tableRoot?.querySelector(
      ".rowSelected",
    ) as HTMLElement | null;

    if (selectedElement) {
      selectedElement.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
      return;
    }

    if (attempt < 5) {
      window.setTimeout(() => scrollToSelectedRow(attempt + 1), 50);
    }
  };

  nextTick(() => {
    window.setTimeout(() => scrollToSelectedRow(), isMobile.value ? 0 : 60);
  });

  return { backgroundColor: "grey" };
}

function deleteRow() {
  let gridrow;
  let rawGridrow;
  if (header.aicBew) {
    gridrow = tableData.value.findIndex(
      (row: QueryDataRow) => row.aic_Bew_pool === aic,
    );
    rawGridrow = lastQueryResponse?.data?.findIndex(
      (row: QueryDataRow) => row.aic_Bew_pool === aic,
    );
  } else {
    gridrow = tableData.value.findIndex(
      (i: QueryDataRow) => i.aic_Stamm === aic,
    );
    rawGridrow = lastQueryResponse?.data?.findIndex(
      (i: QueryDataRow) => i.aic_Stamm === aic,
    );
  }
  aic = 0;
  if (gridrow !== -1) {
    tableData.value.splice(gridrow, 1);
    tableData.value = [...tableData.value]; // datasource refreshen für grid
  }
  if (rawGridrow != null && rawGridrow !== -1 && lastQueryResponse?.data) {
    lastQueryResponse.data.splice(rawGridrow, 1);
  }
  // emit("back");
  emit("onReloadData");
  showLoading.value = false;
}
function dynamicSort(property: any) {
  let sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return (a: any, b: any) => {
    let aVal = a[property];
    let bVal = b[property];

    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return 1 * sortOrder;
    if (bVal == null) return -1 * sortOrder;

    const dateA = toDateSafe(aVal);
    const dateB = toDateSafe(bVal);
    if (dateA && dateB) {
      const result = dateA.getTime() - dateB.getTime();
      return result * sortOrder;
    }

    // Normaler Vergleich (String / Zahl)
    if (typeof aVal === "string" && typeof bVal === "string") {
      const result = aVal.localeCompare(bVal, "de", { numeric: true });
      return result * sortOrder;
    }
    const result = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
    return result * sortOrder;
  };
}

// flexible Datumserkennung und -konvertierung
const MONTHS_DE: Record<string, number> = {
  januar: 0,
  februar: 1,
  märz: 2,
  maerz: 2,
  april: 3,
  mai: 4,
  juni: 5,
  juli: 6,
  august: 7,
  september: 8,
  oktober: 9,
  november: 10,
  dezember: 11,
};

function isDateLike(value: any) {
  return toDateSafe(value) !== null;
}

function toDateSafe(value: any): Date | null {
  if (value instanceof Date && !isNaN(value.getTime())) return value;
  if (typeof value === "number") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value !== "string") return null;
  const v = value.trim();

  let m: RegExpMatchArray | null;

  // dd.MM.yyyy [HH:mm[:ss]]
  m = v.match(
    /^(\d{1,2})\.(\d{1,2})\.(\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/,
  );
  if (m) {
    let year = parseInt(m[3], 10);
    if (year < 100) year += 2000;
    const month = parseInt(m[2], 10) - 1;
    const day = parseInt(m[1], 10);
    const hh = m[4] ? parseInt(m[4], 10) : 0;
    const mm = m[5] ? parseInt(m[5], 10) : 0;
    const ss = m[6] ? parseInt(m[6], 10) : 0;
    const d = new Date(year, month, day, hh, mm, ss);
    return isNaN(d.getTime()) ? null : d;
  }

  // MM/yyyy oder M/yyyy → Tag = 1
  m = v.match(/^(\d{1,2})\/(\d{4})$/);
  if (m) {
    const month = parseInt(m[1], 10) - 1;
    const year = parseInt(m[2], 10);
    const d = new Date(year, month, 1);
    return isNaN(d.getTime()) ? null : d;
  }

  // „Monatname yyyy“ (deutsch)
  m = v.match(/^([A-Za-zÄÖÜäöüß]+)\s+(\d{4})$/);
  if (m) {
    const name = m[1]
      .toLowerCase()
      .replace("ä", "ae")
      .replace("ö", "oe")
      .replace("ü", "ue")
      .replace("ß", "ss");
    const month = MONTHS_DE[name];
    const year = parseInt(m[2], 10);
    if (month !== undefined) {
      const d = new Date(year, month, 1);
      return isNaN(d.getTime()) ? null : d;
    }
  }

  // ISO oder von Date.parse() erkannt
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

function normalizeNumber(value: any): number | null {
  if (value == null) return null;
  if (typeof value === "number") return isNaN(value) ? null : value;
  const s = String(value)
    .replace(/\./g, "")
    .replace(",", ".")
    .replace(/[^\d.-]/g, "");
  const n = parseFloat(s);
  return isNaN(n) ? null : n;
}

function compareValuesByColumn(aVal: any, bVal: any, col: DataColumn): number {
  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return 1;
  if (bVal == null) return -1;

  // Datumsspalten oder datenähnliche Werte
  const da = toDateSafe(aVal);
  const db = toDateSafe(bVal);
  if (da && db) return da.getTime() - db.getTime();

  // Zahl/Währung/Maß
  if (
    col?.type === "zahl" ||
    col?.type === "waehrung" ||
    col?.type === "mass"
  ) {
    const na = normalizeNumber(aVal);
    const nb = normalizeNumber(bVal);
    if (na != null && nb != null) return na - nb;
  }

  // Fallback Stringvergleich
  if (typeof aVal === "string" && typeof bVal === "string") {
    return aVal.localeCompare(bVal, "de", {
      numeric: true,
      sensitivity: "base",
    });
  }
  return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}

function getSortDirection(col: any): "asc" | "desc" {
  const meta = col?.meta ?? {};
  // unterstütze mehrere mögliche Meta-Flags für Absteigend
  if (
    meta.sortDesc === true ||
    meta.desc === true ||
    meta.absteigend === true ||
    meta.richtung === "desc"
  ) {
    return "desc";
  }
  return "asc";
}
function addDruck() {
  if (header && !header.aicBew && !treeviewMutable) {
    const stamm = header.aicStt;
    // const stammTyp = $globalsStt(Globals.Stt, "", stamm);
    mainprintItems = globalsDruck(Globals.Begriff, false, stamm, true);
    if (mainprintItems?.length > 0) {
      showSelect.value = true;
    }
  } else if (props.printItems && props.printItems.length > 0) {
    mainprintItems = props.printItems;
  }
  // wurden vom aufrufenden Formular- der Begriff übergeben - können daraus Drucke etc ausgelesen werden
  if (props.formular) {
    mainprintItems = props.formular.druck ?? [];
  }
}
function openDruckVorschau(item: any) {
  const printItem = item;
  let fullscreen = false;
  let vecStamm: number[] = [];
  let aicLocal = 0;
  if (header.aicStt && item.stt !== header.aicStt) {
    aicLocal = props.queryAic ?? AUApi.Current.user.aic;
  }
  if (selected.value.length > 0) {
    vecStamm = selected.value;
    // selected.value.forEach((element) => {
    //   vecStamm.push(element.aic_Stamm ?? element.aic_Bew_pool);
    // });
  }
  if (selected.value.length === 0 && aicLocal === 0) {
    showSnackbar({
      text: "Bitte wählen Sie zuerst einen Datensatz aus!",
      color: "warning",
    });
    return;
  }
  // console.log("isPhone: " + $isPhone());
  if (isMobile.value) {
    fullscreen = true;
  }
  showDialog({
    title: printItem.bezeichnung,
    site: "BaseDruck",
    fullscreen,
    width: 510,
    data: {
      zeitbereich: lokalZeitbereich.value,
      printItem,
      vecStamm,
      aic: aicLocal,
    },
    onClose: () => {
      return true;
      /* nix tun*/
    },
  });
}
async function onZeitraumChanged(zeitraum: APIZeitbereich) {
  lokalZeitbereich.value = { ...zeitraum };
  tableData.value = [];
  await refresh();
}
type GroupEntry = {
  item: any;
  toggleGroup: (item: any) => void;
  isGroupOpen: (item: any) => boolean;
};

// Nicht-reaktive Map: der group-header-Slot registriert hier bei jedem Render
// seine Vuetify-Callbacks. Waere das reaktiv (frueher ref<Record>), wuerde der
// Schreibzugriff aus der Render-Funktion eine Endlos-Neuberechnung ausloesen
// (allGroupsOpen liest die Sammlung -> Render -> Schreiben -> Render ...).
const groupHeaders = new Map<string, GroupEntry>();
// Reaktiver Zaehler, der NUR hochgezaehlt wird, wenn sich die Menge der
// Gruppen-Keys tatsaechlich aendert - nicht bei jedem Render. Damit koennen
// allGroupsOpen & Co. sauber neu rechnen, ohne Aufschaukeln.
const groupHeadersVersion = ref<number>(0);
const openedGroupValues = ref<Set<string>>(new Set());

function registerGroupHeader(el: unknown, entry: GroupEntry, key: string) {
  if (!el) return;
  // Callbacks immer aktualisieren (Referenzen aendern sich pro Render), aber den
  // reaktiven Zaehler nur bei einem echten neuen Key bumpen - sonst Render-Loop.
  const isNew = !groupHeaders.has(key);
  groupHeaders.set(key, entry);
  if (isNew) groupHeadersVersion.value++;
}

function resetGroupHeaders() {
  if (groupHeaders.size === 0) return;
  groupHeaders.clear();
  groupHeadersVersion.value++;
}

function captureOpenGroups() {
  if (!showGroupBy.value) {
    openedGroupValues.value = new Set();
    return;
  }
  const openValues = Array.from(groupHeaders.values())
    .filter(({ item, isGroupOpen }) => isGroupOpen(item))
    .map(({ item }) => String(item?.value ?? ""))
    .filter((value) => value.length > 0);
  openedGroupValues.value = new Set(openValues);
}

function restoreOpenGroups() {
  if (!showGroupBy.value || openedGroupValues.value.size === 0) {
    return;
  }
  Array.from(groupHeaders.entries()).forEach(([value, entry]) => {
    if (
      openedGroupValues.value.has(String(value)) &&
      !entry.isGroupOpen(entry.item)
    ) {
      entry.toggleGroup(entry.item);
    }
  });
}

const allGroupsOpen = computed(() => {
  // reaktive Abhaengigkeit: neu rechnen, wenn Gruppen (ent)registriert werden.
  void groupHeadersVersion.value;
  const entries = Array.from(groupHeaders.values());
  if (!entries.length) return false;
  // isGroupOpen() liest Vuetifys internen reaktiven Zustand -> beim
  // Auf-/Zuklappen einer einzelnen Gruppe rechnet das computed ebenfalls neu.
  return entries.every(({ item, isGroupOpen }) => isGroupOpen(item));
});

function toggleAllGroups(automOffen?: boolean) {
  const entries = Array.from(groupHeaders.values());
  if (!entries.length) return;

  // Wenn automOffen (forceClose) gesetzt ist, alle Gruppen schließen
  if (automOffen) {
    entries.forEach(({ item, toggleGroup, isGroupOpen }) => {
      if (isGroupOpen(item)) toggleGroup(item);
    });
    return;
  }

  let allOpen = entries.every(({ item, isGroupOpen }) => isGroupOpen(item));
  entries.forEach(({ item, toggleGroup, isGroupOpen }) => {
    if (allOpen) {
      if (isGroupOpen(item)) toggleGroup(item);
    } else {
      if (!isGroupOpen(item)) toggleGroup(item);
    }
  });
}
function onPageChange(newPage: number) {
  page.value = newPage;
}

function onItemsPerPageChange(newItemsPerPag: number) {
  pageSize.value = newItemsPerPag;
  page.value = 1; // Zurück zur ersten Seite
}
const pageCount = computed(() =>
  Math.ceil(tableData.value.length / pageSize.value),
);

function onCalcBtn(args: any) {
  onCalculated(args);
  showCalcMenu.value = false;
}

function onCalculated(args: any) {
  // warum kommt der Emit hier nie an?? Stefan??
  // -> lass deine komponente nie sterben (im menu wenn sie noch was tun soll :)
  onClickLoad();
}
async function onClickLoad() {
  showLoading.value = true;
  await refresh();
}
// }
</script>
<template>
  <v-sheet v-if="initialized && !(props.hideWhenEmpty && noData)">
    <v-toolbar v-if="showClose" class="dvhBackground" style="color: white">
      <div v-if="showTitle" class="pl-2 headline font-weight-light white--text">
        {{ title }}
      </div>
      <v-spacer></v-spacer>
      <v-switch
        v-if="letzteDatenAnzeigen"
        v-model="letzteDaten"
        label="alle Daten"
        @update:modelValue="onClickLoad"
      ></v-switch>
      <v-btn dark icon="mdi-close" @click="emit('back')" v-if="showClose">
      </v-btn>
    </v-toolbar>
    <v-data-table
      :key="`${setCompKey}-${selectedRow}`"
      v-if="initialized"
      v-model="selected"
      dense
      fixed
      :headers="
        headers.map((h) =>
          h.key === 'data-table-group' || h.value === 'data-table-group'
            ? {
                ...h,
                title: '1',
                text: '1',
                label: '1',
                value: 'data-table-group',
                key: 'data-table-group',
              }
            : h,
        )
      "
      :items="tableData"
      :items-per-page="pageSize"
      :page="page"
      :server-items-length="tableData.length"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      show-current-page
      class="elevation-2"
      fixed-header
      :item-value="rowKey"
      :sort-by="sortBy"
      :groupBy="groupedBy"
      group-expand
      :multi-sort="false"
      :search="search"
      @update:expanded="loadDetails"
      :locale="localeZeit"
      :hide-default-footer="disableFooter"
      :disable-pagination="disableFooter"
      :show-select="showSelect"
      :item-selectable="(item) => item.id !== -1"
      select-strategy="all"
      :loading="showLoading"
      loading-text="Loading... Please wait"
      :hide-default-header="isMobile"
      :item-class="itemRowBackground"
      :row-props="rowProps"
      :min-width="isMobile ? 'auto' : '100%'"
      :show-expand="showExpand"
      single-expand
      :show-group-by="false"
      :mobile="isMobile"
    >
      <template
        v-for="col in visibleColumns"
        :key="`header.${col.name}`"
        v-slot:[`header.${col.name}`]="{ column }"
      >
        <th
          :class="[`th-fixed-width-${col.name}`]"
          :style="getHeaderStyle(col)"
        >
          {{ column.title }}
        </th>
      </template>

      <template
        v-for="col in checkboxColumns"
        :key="`checkbox-${col.name}`"
        v-slot:[`item.${col.name}`]="{ item }"
      >
        <v-checkbox-btn
          :model-value="item[col.name]"
          color="primary"
          density="compact"
          readonly
          :class="
            isMobile ? 'd-flex justify-end pr-2' : 'd-flex justify-center'
          "
        />
      </template>
      <template v-slot:loading>
        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
      </template>
      <template
        v-for="col in ampelColumns"
        :key="`ampel-${col.name}`"
        v-slot:[`item.${col.name}`]="{ item }"
      >
        <v-icon :color="getAmpelColor(item[col.name])" size="x-large"
          >mdi-circle-slice-8</v-icon
        >
      </template>
      <template v-slot:top>
        <v-toolbar
          :color="props.color ?? '#FFD8B1'"
          v-if="
            showBezeichnung ||
            showSearch ||
            showZeitraum ||
            (mainprintItems && mainprintItems.length > 0) ||
            (mainexportItems && mainexportItems.length > 0) ||
            (modellItems && modellItems.length > 0) ||
            dialogEdit
          "
          density="compact"
        >
          <v-toolbar-title v-if="showBezeichnung"
            >{{ bezeichnung }}
          </v-toolbar-title>
          <v-spacer v-if="showBezeichnung && !isMobile"></v-spacer>
          <v-menu v-if="showZeitraum" v-model="menu">
            <template v-slot:activator="{ props }">
              <SelectZeitraum
                v-bind="props"
                :close-on-content-click="false"
                @updateZeitbereich="onZeitraumChanged"
                v-model="lokalZeitbereich"
                color="black"
              ></SelectZeitraum>
            </template>
          </v-menu>
          <v-spacer v-if="!showBezeichnung || isMobile"></v-spacer>
          <v-btn
            v-if="!isMobile"
            variant="text"
            :disabled="showLoading"
            @click="onClickLoad"
            icon="mdi-refresh"
          ></v-btn>
          <v-btn
            v-if="showGroupBy && isMobile"
            class="pa-0"
            variant="text"
            @click="toggleAllGroups()"
            propend-icon="mdi-menu-open"
          ></v-btn>
          <v-btn
            v-else-if="showGroupBy && !isMobile"
            variant="text"
            @click="toggleAllGroups()"
            prepend-icon="mdi-menu-open"
            >{{
              allGroupsOpen ? "Alle Gruppen schließen" : "Alle Gruppen öffnen"
            }}</v-btn
          >
          <v-menu
            v-if="
              initialized &&
              !treeviewMutable &&
              mainprintItems &&
              mainprintItems.length > 0 &&
              tableData &&
              tableData.length > 0
            "
          >
            <template v-slot:activator="{ props }">
              <v-btn
                icon="mdi-printer-outline"
                variant="text"
                v-bind="props"
              ></v-btn>
            </template>

            <v-list
              lines="one"
              class="shortList"
              nav
              tile
              outlined
              elevation="12"
            >
              <v-list-item
                class="pl-2"
                v-for="(printItem, ux) in mainprintItems"
                :key="'ui' + ux"
                @click="openDruckVorschau(printItem)"
              >
                <v-tooltip
                  :disabled="!printItem.tooltip"
                  location="bottom"
                  :text="printItem.tooltip"
                >
                  <template v-slot:activator="{ props }">
                    <v-list-item-title
                      v-bind="props"
                      v-text="printItem.bezeichnung"
                    >
                    </v-list-item-title>
                  </template>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu
            v-model="showCalcMenu"
            location="bottom"
            v-if="
              initialized &&
              !treeviewMutable &&
              modellItems &&
              modellItems.length > 0 &&
              tableData &&
              tableData.length > 0
            "
            class="pa-0"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                varaint="text"
                v-bind="props"
                style="width: 20px"
                icon="mdi-play-circle-outline"
              >
              </v-btn>
            </template>
            <v-list class="shortList" nav tile outlined elevation="12">
              <v-list-item
                class="pl-2"
                v-for="(modellItem, ux) in modellItems"
                :key="'ui' + ux"
              >
                <CalcButton
                  :text="modellItem.bezeichnung"
                  :modell="modellItem.kennung"
                  :icon="modellItem.icon"
                  :dark="false"
                  :color="modellItem.farbe"
                  variant="plain"
                  :vecStamm="selected"
                  :useVecStamm="showSelect"
                  @calculated="onCalcBtn"
                  :zeitbereich="lokalZeitbereich"
                  :bewAic="modellItem.bewegung ?? false"
                />
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu
            v-if="showSearch"
            :close-on-content-click="false"
            location="end"
            class="pa-0"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                class="pa-0"
                variant="text"
                v-bind="props"
                icon="mdi-magnify"
              >
              </v-btn>
            </template>
            <v-card min-width="300">
              <v-card-text>
                <v-text-field
                  :label="globalsBezeichnung(Globals.Begriff, 'Suche', 'Suche')"
                  autofocus
                  v-model="search"
                  single-line
                  variant="outlined"
                  density="compact"
                  append-inner-icon="mdi-magnify"
                  :hide-details="true"
                  :clearable="true"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-btn
            variant="text"
            class="pa-0"
            v-if="showNew && dialogEdit"
            @click="newItem()"
            icon="mdi-plus"
          >
          </v-btn>
          <v-dialog
            v-if="dialogOpen"
            v-model="dialogOpen"
            :max-height="dialog.height ?? 400"
            :max-width="dialog.width ?? 400"
            :fullscreen="dialog.fullscreen"
            class="pa-0 ma-0"
          >
            <BaseEditor
              v-if="!dialog.showCustomEditor"
              :query="dialog.query"
              @back="onBack"
              @save="(item: any) => onBack(item)"
              :aic="dialog.aic"
              :mainAic="dialog.mainAic"
              :mainStt="dialog.mainStt"
              :zeitbereich="lokalZeitbereich"
              :bewegungsdaten="dialog.bewegungsdaten"
              :showTitle="true"
              :lastValues="dialog.lastValues"
              :showDeleteButton="false"
              :showBackButton="true"
              :backOnSave="true"
              :newData="dialog.newData"
              :openFromDialog="true"
              style="padding: 4px !important"
              :maxWidth="dialog.width ?? 400"
              :maxHeight="dialog.height ?? 400"
              :mehrfach="dialog.mehrfach"
            />
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-text>{{ frageDelete }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  variant="text"
                  prepend-icon="mdi-cancel"
                  @click="closeDelete"
                >
                  {{ begriffBezeichnung("Abbruch") }}</v-btn
                >
                <v-btn
                  color="red darken-1"
                  variant="text"
                  prepend-icon="mdi-delete"
                  @click="(item: any) => deleteItem(item)"
                >
                  {{ begriffBezeichnung("Loeschen") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogCopy" max-width="500px">
            <v-card>
              <v-card-title class="text-h8">{{ frageCopy }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  variant="text"
                  prepend-icon="mdi-cancel"
                  @click="closeCopy"
                >
                  {{ begriffBezeichnung("Abbruch") }}</v-btn
                >
                <v-btn
                  v-if="showCopy"
                  color="blue darken-1"
                  variant="text"
                  @click="copyItem()"
                  prepend-icon="mdi-content-copy"
                >
                  Kopie</v-btn
                >
                <v-btn
                  v-if="showCopyStamm"
                  color="blue darken-1"
                  variant="text"
                  @click="copyStamm()"
                  prepen-icon="mdi-content-copy"
                >
                  Stamm - Kopie</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-if="dialogVerwendung && !dialog.showCustomEditor"
            eager
            leave-absolute="true"
            v-model="dialogVerwendung"
            :width="dialog.width"
            :height="dialog.height"
            :fullscreen="dialog.fullscreen"
            class="pa-0 ma-0"
          >
            <BaseVGrid
              v-if="!dialog.showCustomEditor"
              :query="dialog.query"
              :queryAic="dialog.mainAic"
              :mainStt="dialog.mainStt"
              :zeitbereich="dialog.zeitbereich"
              :bewegungsdaten="dialog.bewegungsdaten"
              :mainprintItems="dialog.printItems"
              :showClose="true"
              @back="dialogBack"
            />
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:group-header="{ item, toggleGroup, isGroupOpen }">
        <tr
          :style="{ backgroundColor: '#D0EBFF' }"
          :ref="
            (el) =>
              registerGroupHeader(
                el,
                { item, toggleGroup, isGroupOpen },
                String(item.value ?? ''),
              )
          "
        >
          <td v-if="showSelect" class="tdZwischenSum white--text">&nbsp;</td>
          <td class="group-header-label-cell">
            <div
              class="d-flex align-center group-header-label-wrapper"
              style="justify-content: flex-start"
            >
              <VBtn
                :icon="isGroupOpen(item) ? '$expand' : '$next'"
                size="small"
                variant="text"
                class="me-2"
                @click="toggleGroup(item)"
              />
              <span
                class="group-header-label-text"
                style="font-weight: normal; text-align: left"
              >
                {{ getGroupHeaderLabel(item.value) }}
              </span>
            </div>
          </td>
          <td
            v-for="(col, ix) in summaryColumns"
            :key="`gs-${item.value}-${ix}`"
            class="tdZwischenSum"
            :style="getColStyle(col)"
          >
            {{ getSubTotal(col, item.items) }}
          </td>
          <td v-if="dialogInlineEdit" class="tdZwischenSum white--text">
            &nbsp;
          </td>
        </tr>
      </template>
      <template v-slot:expanded-row="{ columns, item }">
        <tr>
          <td :colspan="expandColspan">
            <div class="expand-wrapper rounded-lg pa-2">
              <v-progress-linear
                color="dvhSlider"
                :indeterminate="true"
                v-if="showLoadingSub"
              ></v-progress-linear>

              <BaseVGrid
                v-if="!showLoadingSub && expandDataSet"
                :preloadedData="expandDataSet"
                :query="query"
                :disableFooter="true"
                :dark="true"
                :mainStt="mainSttInternal"
                :mainAic="mainAicInternal"
                :printItems="mainprintItems"
                color="blue"
              />
            </div>
          </td>
        </tr>
      </template>
      <template
        v-slot:item.data-table-expand="{
          internalItem,
          isExpanded,
          toggleExpand,
        }"
      >
        <v-icon
          v-if="showExpand"
          size="small"
          @click="toggleExpand(internalItem)"
          style="cursor: pointer"
        >
          {{ isExpanded(internalItem) ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn-group class="pa-0">
          <v-btn
            v-if="dialogInlineEdit"
            size="small"
            color="green"
            class="mr-2"
            @click="editItem(item)"
            icon="mdi-pencil"
            variant="text"
            density="compact"
          >
          </v-btn>

          <v-btn
            size="small"
            color="red"
            v-if="showDelete || (showDeleteDetail && item.allowDelete)"
            @click="deleteItemDialog(item)"
            icon="mdi-delete"
            variant="text"
            density="compact"
          >
          </v-btn>

          <v-btn
            v-if="showVerwendung"
            size="small"
            @click="openVerwendung(item)"
            icon="mdi-magnify"
            variant="text"
            density="compact"
          >
          </v-btn>
          <v-btn
            v-if="showCopy || showCopyStamm"
            size="small"
            @click="copyItemDialog(item)"
            icon="mdi-content-copy"
            variant="text"
            density="compact"
          >
          </v-btn>
        </v-btn-group>
      </template>
      <template
        v-slot:header.data-table-select="{
          allSelected,
          selectAll,
          someSelected,
        }"
      >
        <v-checkbox-btn
          :indeterminate="someSelected && !allSelected"
          :model-value="allSelected"
          color="primary"
          @update:modelValue="selectAll(!allSelected)"
        ></v-checkbox-btn>
      </template>
      <template
        v-slot:item.data-table-select="{
          internalItem,
          isSelected,
          toggleSelect,
        }"
      >
        <v-checkbox-btn
          :model-value="isSelected(internalItem)"
          color="primary"
          @update:model-value="toggleSelect(internalItem)"
        ></v-checkbox-btn>
      </template>
      <template #body.append>
        <tr
          v-if="
            !noData &&
            ((!treeviewMutable && aggregateColumns.length > 0) ||
              !disableFooter) &&
            !isMobile
          "
          class="sum-row"
        >
          <td v-if="showSelect" class="tdSum white--text">&nbsp;</td>

          <td v-if="showGroupBy" class="tdSum white--text">
            {{ begriffBezeichnung("Gesamtsumme", "Gesamtsumme") }}
          </td>
          <td
            v-for="(col, ix) in summaryColumns"
            :key="'f' + ix"
            class="tdSum"
            :class="{
              'tdSum-right':
                col.type === 'zahl' ||
                col.type === 'waehrung' ||
                col.type === 'mass',
            }"
            :style="getColStyle(col)"
          >
            {{ getFooter(col) }}
          </td>
          <td
            v-for="n in summaryExtraCells"
            :key="'fx' + n"
            class="tdSum white--text"
          ></td>
        </tr>
      </template>
      <template #bottom>
        <v-pagination
          v-if="!disableFooter"
          v-model="page"
          :length="pageCount"
          total-visible="7"
        />
      </template>
    </v-data-table>
  </v-sheet>
</template>
<style scoped>
:deep(.rowSelected > td) {
  background-color: rgb(197, 195, 195) !important;
}
:deep(.rowSelected) {
  background-color: rgb(197, 195, 195) !important;
}

.v-table > .v-table__wrapper > table > tbody > tr > td {
  padding: 0px !important;
}
.tdSum {
  color: red;
  display: table-cell;
  text-align: end;
}
.tdSum-right {
  padding-right: 20px;
}
/* .v-table > ... > td { padding: 0px !important } oben gewinnt sonst gegen .tdSum-right,
   da !important immer schlaegt - deshalb hier gleiche Spezifitaet + !important */
.v-table > .v-table__wrapper > table > tbody > tr.sum-row > td.tdSum-right {
  padding-right: 20px !important;
}
.sum-row td {
  border-top: 2px solid darkred;
}

/* Gruppierte Zeilen kompakt halten */

/* Kompaktes, sauberes Design für group-header mit Subtotal-Zellen */
:deep(.v-data-table__tr--group-header) {
  height: 28px !important;
  min-height: 28px !important;
}

:deep(.v-data-table__tr--group-header > td.group-header-label-cell) {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  height: 28px !important;
  min-height: 28px !important;
  line-height: 1.2 !important;
  vertical-align: middle !important;
  max-width: none !important;
  width: auto !important;
  min-width: 0 !important;
  white-space: nowrap !important;
  text-align: left !important;
}

.group-header-label-wrapper {
  flex-wrap: nowrap !important;
  min-width: 0;
}

.group-header-label-text {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
}

:deep(.v-data-table__tr--group-header .d-flex.align-center) {
  min-height: 24px !important;
  align-items: center !important;
}

:deep(.v-data-table__tr--group-header .v-btn) {
  min-width: 22px !important;
  width: 22px !important;
  height: 22px !important;
  margin-right: 4px !important;
}

.tdZwischenSum {
  font-size: 0.95em;
  color: #444;
  background: transparent;
  padding: 0 6px !important;
  text-align: right;
  vertical-align: middle;
}

/* Header-Zellen niemals umbrechen */
:deep(.v-data-table thead th),
:deep(.v-data-table thead th .v-data-table-header__content),
:deep(.v-data-table thead th span) {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Data-table columns padding */
:deep(.v-data-table__td) {
  padding: 0 6px !important;
}

:deep(.v-data-table-column) {
  padding: 0 6px !important;
}

:deep(th.th-checkbox-header .v-data-table-header__content) {
  justify-content: center !important;
  text-align: center !important;
}

/* Expand-Spalte minimal */
:deep(.v-data-table__td[data-key="data-table-expand"]) {
  width: 20px !important;
  min-width: 20px !important;
  padding: 0 4px !important;
  text-align: center;
}

.expand-wrapper {
  overflow-x: auto;
  max-width: 100%;
}
.right-padding-cell {
  padding-right: 10px !important;
}

/* Rechtes Padding für rechtsbündige Zellen */
:deep(.v-data-table__td.v-data-table-column--align-end) {
  padding-right: 20px !important;
}

@media (max-width: 600px) {
  :deep(.v-sheet) {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  :deep(.v-table__wrapper) {
    max-height: calc(100vh - 220px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  :deep(.v-data-table) {
    width: 100% !important;
    overflow-x: hidden !important;
  }

  :deep(.v-data-table thead th) {
    text-align: left !important;
  }

  :deep(.v-data-table thead th .v-data-table-header__content) {
    justify-content: flex-start !important;
    text-align: left !important;
  }

  :deep(
    .v-data-table
      thead
      th.v-data-table-column--align-end
      .v-data-table-header__content
  ) {
    justify-content: flex-start !important;
  }

  :deep(th.th-checkbox-header .v-data-table-header__content) {
    justify-content: center !important;
    text-align: center !important;
  }

  /* Alternativ gefärbte Zeilen in Mobile für bessere Lesbarkeit */
  :deep(.v-data-table tbody tr:nth-child(odd)) {
    background-color: rgba(0, 0, 0, 0.06) !important;
  }

  :deep(.v-data-table tbody tr:nth-child(even)) {
    background-color: rgba(0, 0, 0, 0) !important;
  }
}
:deep(th[data-column-key="data-table-group"]) {
  color: transparent !important;
  min-width: 24px !important;
  width: 24px !important;
  pointer-events: none;
}
</style>
